const perPageParams = [10, 20, 30];

export default perPageParams;
